module.exports = {"title":"Escolher Avatar"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/ChooseAvatar/data.json
// module id = 1686
// module chunks = 0